import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroSlides } from '@/mocks/data';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const goTo = (index: number) => setCurrent(index);

  return (
    <section className="relative h-[520px] md:h-[640px] overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
      ))}

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="w-full max-w-3xl">
          {heroSlides.map((slide, i) => (
            <div
              key={slide.id}
              className={`transition-all duration-500 ${
                i === current
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-4 absolute inset-x-0 top-1/2 -translate-y-1/2'
              }`}
            >
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
                {slide.title}
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
                {slide.subtitle}
              </p>
              <button
                onClick={() => {
                  navigate(slide.link);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {slide.cta}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 z-10 flex items-center justify-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? 'bg-white w-8' : 'bg-white/40 hover:bg-white/60'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}